import { render, staticRenderFns } from "./OrnamentHistory.vue?vue&type=template&id=44d2cd5a&scoped=true"
import script from "./OrnamentHistory.vue?vue&type=script&lang=js"
export * from "./OrnamentHistory.vue?vue&type=script&lang=js"
import style0 from "./OrnamentHistory.vue?vue&type=style&index=0&id=44d2cd5a&prod&lang=less&scoped=true"
import style1 from "./OrnamentHistory.vue?vue&type=style&index=1&id=44d2cd5a&prod&lang=less"
import style2 from "./OrnamentHistory.vue?vue&type=style&index=2&id=44d2cd5a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2cd5a",
  null
  
)

export default component.exports